module.exports = __webpack_public_path__ + "img/mi_perfil_avatar.16633744.jpg";